<template>
  <div>
    <CompDialog :isShow="isShow" @close="isShow = false">
      <div class="details">
        <article>
          <div class="details-item">
            <span> {{ invoiceTypeMap[invoiceDetailData.invoice_type] }}</span>
          </div>
          <div class="details-item">
            <span>金额(元) ： </span
            ><span class="value" v-text="invoiceDetailData.amount"></span>
          </div>
          <div class="details-item">
            <span>发票抬头：</span>
            <!-- <div class="empty"></div> -->
            <span class="value" v-text="invoiceDetailData.title_name"></span>
          </div>
          <div
            v-if="invoiceDetailData.title_type === 'enterprise'"
            class="details-item"
          >
            <span>税号：</span>
            <!-- <div class="empty"></div> -->
            <span class="value" v-text="invoiceDetailData.tax_code"></span>
          </div>
          <div class="details-item">
            <span>邮箱 ： </span
            ><span class="value" v-text="invoiceDetailData.email"></span>
          </div>
        </article>

        <article
          v-if="
            moreInfos.length && invoiceDetailData.title_type === 'enterprise'
          "
          class="more-info"
        >
          <header>
            <span>更多信息</span>
          </header>
          <div class="info-contents">
            <div
              v-for="(item, index) in moreInfos"
              :key="index"
              class="contents-item"
            >
              <span class="content-item-title" v-text="item.label"></span>
              <span class="content-item-value" v-text="item.value"></span>
            </div>
          </div>
        </article>

        <div class="tip-text">
          <span>是否确认开票？发票开具后不可更改</span>
        </div>
        <div class="footer">
          <div class="btn cancle-btn" @click="isShow = false">取消</div>
          <div class="btn comfirm-btn" @click="comfirm">确定</div>
        </div>
      </div>
    </CompDialog>
  </div>
</template>

<script>
import CompDialog from '../../../../components/comp-dialog/comp-dialog.vue';

export default {

  components: {
    CompDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },

    moreInfos: {
      type: Array,
      default: function () {
        return [];
      },
    },

    invoiceDetailData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  data() {
    return {
      invoiceTypeMap: {
        electronic: '电子发票',
        paper: '纸质发票',
      },
    };
  },

  computed: {
    isShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      },
    },
  },

  methods: {
    comfirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="scss" scoped>
.details {
  position: absolute;
  top: 50%;
  width: 602px;
  min-height: 560px;
  margin: auto;
  padding: 48px 48px 50px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  background-color: #fff;
  border-radius: 8px;
  transform: translateY(-50%);
  .details-item {
    display: flex;
    align-items: baseline;
    text-align: justify;
    word-break: break-all;
    span {
      color: #383333;
      font-size: 28px;
      // vertical-align: text-top;
    }

    .value {
      display: inline-block;
      width: 306px;
      text-align: justify;
      word-break: break-all;
    }
    & + .details-item {
      margin-top: 20px;
    }
  }
}

.more-info {
  &:before {
    display: block;
    width: 100%;
    margin-top: 31.5px;
    border-top: 1px dashed #040404;
    opacity: 0.8;
    content: '';
  }
  header {
    padding-top: 31px;
    color: #383333;
    font-size: 28px;
    text-align: left;
  }

  .info-contents {
    padding-top: 24px;
    color: #383333;
    font-weight: normal;
    font-size: 24px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    opacity: 0.6;
  }

  .contents-item {
    display: flex;
    align-items: baseline;
    & + .content-item-item {
      margin-top: 19px;
    }

    .content-item-value {
      flex: 1;
      text-align: right;
    }
  }
}

.tip-text {
  margin-top: 60px;
  color: #383333;
  font-size: 30px;
}

.footer {
  display: flex;
  align-items: center;
  margin-top: 62px;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 225px;
    height: 78px;
    font-weight: normal;
    font-size: 30px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    border-radius: 100px;
    &:active {
      opacity: 0.8;
    }
    &.cancle-btn {
      color: #898585;
      border: solid 2px #898585;
    }

    &.comfirm-btn {
      color: #fff;
      background-color: #6749ec;
    }

    & + .btn {
      margin-left: 32px;
    }
  }
}
</style>
